import React from "react";
import MainStore from "../stores/MainStore";
import db, { realDb } from "./../firebase/fireInit";
import { ref, set, onValue, onDisconnect } from "firebase/database";
import { useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";

const useHandleRealTimeDB = () => {
  const { player } = MainStore();

  useEffect(() => {
    if (player) {
      var uid = player.uid;
      const playerRef = doc(db, "players", uid);
      const userStatusDatabaseRef = ref(realDb, "/status/" + uid);

      var isOfflineForDatabase = {
        state: "offline",
        last_changed: Date.now(),
      };

      var isOnlineForDatabase = {
        state: "online",
        last_changed: Date.now(),
      };
      const connectedRef = ref(realDb, ".info/connected");
      onValue(connectedRef, (snapshot) => {
        // If we're not currently connected, don't do anything.
        if (snapshot.val() == false) {
          return;
        }
        onDisconnect(userStatusDatabaseRef)
          .set(isOfflineForDatabase)
          .then(() => {
            set(userStatusDatabaseRef, isOnlineForDatabase);
            updateDoc(playerRef, { online: isOnlineForDatabase });
          });
      });
    }
  }, [player?.uid]);
};

export default useHandleRealTimeDB;
